import Icon from '../../../components/AppIcon';

const PointsSystemSection = () => {
  const rewards = [
    {
      id: 1,
      points: "5 puntos",
      action: "Por cada referido exitoso",
      icon: "Award"
    },
    {
      id: 2,
      points: "1.000 puntos",
      reward: "$1.000.000 COP",
      icon: "Gift"
    },
    {
      id: 3,
      minimum: "$200.000 COP",
      action: "Retiro mínimo a billeteras digitales o bancos",
      icon: "Wallet"
    }
  ];

  return (
    <section className="py-12 sm:py-14 md:py-16 lg:py-20 px-4 sm:px-6 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-14 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3 sm:mb-4 px-2">
            Sistema de Puntos y Recompensas
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto px-4">
            Acumula puntos por cada referido y gana bonos especiales en efectivo
          </p>
        </div>

        <div className="bg-card rounded-xl sm:rounded-2xl shadow-card p-5 sm:p-6 md:p-7 lg:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {rewards?.map((reward) => (
              <div
                key={reward?.id}
                className="bg-muted rounded-lg sm:rounded-xl p-4 sm:p-5 md:p-6 text-center"
              >
                <div className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12 bg-primary text-primary-foreground rounded-lg mx-auto mb-3 sm:mb-3.5 md:mb-4">
                  <Icon name={reward?.icon} size={20} className="sm:hidden" />
                  <Icon name={reward?.icon} size={22} className="hidden sm:block md:hidden" />
                  <Icon name={reward?.icon} size={24} className="hidden md:block" />
                </div>
                {reward?.points && (
                  <div className="text-xl sm:text-2xl font-bold text-primary mb-1.5 sm:mb-2">
                    {reward?.points}
                  </div>
                )}
                {reward?.reward && (
                  <div className="text-xl sm:text-2xl font-bold text-success mb-1.5 sm:mb-2">
                    {reward?.reward}
                  </div>
                )}
                {reward?.minimum && (
                  <div className="text-xl sm:text-2xl font-bold text-foreground mb-1.5 sm:mb-2">
                    {reward?.minimum}
                  </div>
                )}
                <p className="text-xs sm:text-sm text-muted-foreground">
                  {reward?.action}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PointsSystemSection;